import {
  NavigationProp,
  useNavigation,
  useRoute,
} from '@react-navigation/native';
import {ShopStackParams} from '../../types/nav';
import {OrderParams} from './order';
import {useMutation, useQuery} from 'react-query';
import {getById, getFileReaderOpfs} from '../../api';
import {
  Button,
  Divider,
  IconButton,
  List,
  Text,
} from 'react-native-paper';
import * as ethers from 'ethers';
import {
  createChunks,
  encryptAesKey,
  encryptPayload,
  encryptPayloadRaw,
  generateAesKey,
  maxSize,
} from '../../api/ssl';
import {decryptPayloadD} from '../../api/shop';
import {Media, Product} from '../../types';
import {pinFileToIPFS} from '../../api/pin';
import {getOrderById} from '../../api/exchange';
export function OrderItem(props: {
  item: Awaited<ReturnType<typeof getOrderById>>;
  ordersQuery: ReturnType<typeof useQuery>;
  shopId: string;
}) {
  const userDataQuery = useQuery(
    'decrypt_' + props.item.id,
    async () => await decryptPayloadD(props.item.encData),
  );
  const navigation = useNavigation<NavigationProp<ShopStackParams>>();
  const route = useRoute();
  const params = route.params as OrderParams;
  const userData = userDataQuery.data;
  const deliveryMutation = useMutation(
    async (item: Awaited<ReturnType<typeof getOrderById>>) => {
      const abiCoder = new ethers.AbiCoder();
      const aesKey = await generateAesKey();
      const encryptedKey = await encryptAesKey(
        aesKey.kp,
        JSON.parse(userData.publicKey),
      );
      const uploadEncrypt = async (
        file: File | Blob,
        media: Media,
        partId: number,
      ) => {
        const encryptedFile = await encryptPayloadRaw(
          aesKey.key,
          await file.arrayBuffer(),
        );
        console.info('encryptedFile', encryptedFile);
        const bl = new Blob([encryptedFile.buffer], {
          type: 'text/plain',
        }) as File;
        (bl as any).name = media.filename;
        console.info('bl', bl);
        const fileLink = await pinFileToIPFS(bl);
        return {
          fileLink,
          iv: encryptedFile.iv,
          name: media.filename,
          fileType: media.fileType,
          partId,
        };
      };
      // const
      // console.info('userData', userData, props.shopId)
      const cartLinks = [];
      // await Promise.all(
      //   userData.cart.map(async (c: {id: string}) => {
      //     const media = (await getById(c.id, props.shopId)) as Product;
      //     const file = (await getFileReaderOpfs(media)) as File;

      //     console.info('file', file);

      //     if (file.size > maxSize) {
      //       const splits = createChunks(file);
      //       const links = await Promise.all(
      //         splits.map((i, index) =>
      //           uploadEncrypt(i, media, index),
      //         ),
      //       );
      //       return links;
      //     }

      //     return await uploadEncrypt(file, media, 0);
      //   }),
      // );
      const {encryptedPayload, iv} = await encryptPayload(
        aesKey.key,
        JSON.stringify(cartLinks),
      );
      const dataBlob = abiCoder.encode(
        ['string'],
        [JSON.stringify({encryptedPayload, iv, encryptedKey})],
      );
      await (await item.contract.confirmDelivery(dataBlob)).wait(1);
    },
    {
      onSuccess: async () => {
        await props.ordersQuery.refetch();
      },
    },
  );
  return (
    <>
      <List.Accordion
        style={{backgroundColor: 'black'}}
        left={lp => (
          <Text {...lp} style={{...lp.style, fontSize: 10}}>
            {props.item.state}
          </Text>
        )}
        key={props.item.id}
        onPress={() => {
          if (props.item.id === params?.orderId)
            navigation.navigate('Orders', {
              orderId: undefined,
            });
          else
            navigation.navigate('Order', {
              orderId: props.item.id,
            });
        }}
        right={p => (
          <IconButton
            {...p}
            icon={
              params?.orderId === props.item.id ? 'chevron-right' : ''
            }
          />
        )}
        expanded={params?.orderId === props.item.id}
        title={'ORDER: ' + props.item?.id}
        description={
          <>
            <Text style={{fontSize: 12}}>
              {'Address: ' +
                userData?.deliveryAddress +
                '\nPrice: ' +
                props.item.price +
                (props.item.rating > 0
                  ? ' Rating: ' + props.item.rating
                  : ' ')}
            </Text>
            {props.item.state === 'Locked' && (
              <Button
                icon={'truck'}
                loading={deliveryMutation.isLoading}
                onPress={() =>
                  deliveryMutation.mutateAsync(props.item)
                }>
                {'Confirm Delivery'}
              </Button>
            )}
          </>
        }>
        <></>
      </List.Accordion>
      <Divider />
    </>
  );
}
